import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Outlet } from "react-router-dom";
import { Box, Container, CssBaseline } from "@mui/material";

import FooterReserved from "./innerComponent/FooterReserved";
import LargeFooter from "./ProfileLayout/FOOTER/LargeFooter";
import ScrollToTop from "../components/other/ScrollToTop";

import "./innerComponent/styles/navbarmenu.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import DesktopHeaderBell from "../components/christmasDayUIDesign/components/DesktopHeaderBell";
import Navbar from "./Navbar";
import NavbarMenu from "./innerComponent/NavbarMenu";

const SHOW_BELL_BEFORE = 280;

const useHeaderVisibility = () => {
  const [visible, setVisible] = useState(true);
  const ticking = useRef(false);

  const handleScroll = () => {
    if (ticking.current) return;

    ticking.current = true;

    requestAnimationFrame(() => {
      const currentY = window.scrollY;

      // 🔔 Bell ONLY when user is near top
      if (currentY <= SHOW_BELL_BEFORE) {
        setVisible(true);
      } else {
        setVisible(false);
      }

      ticking.current = false;
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return visible;
};


const Layout = () => {
  const isBellVisible = useHeaderVisibility();

  return (
    <React.Fragment>
      <CssBaseline />
      <ScrollToTop />
      <Box
        sx={{
          maxWidth: "100%",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: 'white.main',
          minHeight: "100vh",
          margin: 0,
          padding: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: {
              md: 175,
              xl: 220
            },
            backgroundColor: '#da3966ff',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1200,
              transform: isBellVisible ? 'translateY(0)' : 'translateY(-100%)',
              opacity: 1,
              transition: 'transform 0.42s cubic-bezier(0.25, 0.8, 0.25, 1)',
              backdropFilter: 'blur(100px)',
              willChange: 'transform',
            }}
          >
            <DesktopHeaderBell />
          </Box>

          <Box
            sx={{
              position: "fixed",
              top: isBellVisible ? 70 : 0,
              width: "100%",
              height: {
                md: 105,
                xl: 150
              },
              // overflow: "hidden",
              zIndex: 1100,

              transition: 'top 0.38s cubic-bezier(0.25, 0.8, 0.25, 1)',
              willChange: 'top',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',

                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'white.main',
              }}
            >
              {/* <Box sx={{ width: '100%', height: 70, backgroundColor: 'blue' }} />
              <Box sx={{ width: '100%', height: 50, backgroundColor: '#c22c2cff' }} /> */}
              <Navbar />
              <NavbarMenu />
            </Box>
          </Box>
        </Box>

        {/* Main Content Area with padding for fixed headers */}
        <Box
          component="main"
          sx={{
            flex: 1,
            width: "100%",
            height: "100%",
          }}
        >
          <Outlet />
        </Box>

        {/* Footer Section */}
        <Box sx={{ width: "100%" }}>
          <LargeFooter />
          <FooterReserved />
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default React.memo(Layout);
